export default {
    setFeedDetail(state, payload) {
        state.feedDetail = payload;
    }
}